<template lang='pug'>
div
    SignalGeneratorSelectorLinks
    div.fullwidth(v-if="$route.params.lang == 'de'")

        div.title-container
            h1.product-title HFIG-600(-S)
            .subtitle Breitbandiger VHF/UHF Impulsgenerator mit bis zu 600 V Ausgangsspannung

        div.margin-bottom-30
            .column-container
                .column.center-content
                    picture.main-product-picture
                        source(type='image/avif', srcset='@/assets/photos/product_shots/HFIG-600.avif')
                        source(type='image/webp', srcset='@/assets/photos/product_shots/HFIG-600.webp')
                        img( src='@/assets/photos/product_shots/HFIG-600.png', width="50%", alt='VHF/UHF Impulsgenerator HFIG-600', title='VHF/UHF Impulsgenerator HFIG-600')

                .column.factsandbluebox
                    .factbox
                        span.headline Highlights:
                        ul
                            li Hohe Bandbreite: 1&nbsp;GHz (-1&nbsp;dB) / 1,7&nbsp;GHz (-3&nbsp;dB)
                            li Kurze Anstiegszeit 80&nbsp;ps
                            li Impulsdauer 200&nbsp;ps
                            li Ausgangsspannung bis zu 600&nbsp;V an 50&nbsp;Ω
                            li Akkubetrieb
                            li Steuerbar per LWL in der S-Version
                            li Verschiedene Triggeroptionen
                    .bluebox
                        //- Downloadlink(text='Datenblatt (pdf, deutsch)', link="/pdf/Datenblatt HFIG-600.pdf")
                        Downloadlink(text='Datasheet (pdf, english)', link="/pdf/Datasheet HFIG-600.pdf")
                        Maillink(to='support@bss-hs.de', sub='HFIG-600', text='Kontakt', size=30, strokeWidth=2)
                        Sitelink(to="/de/products/pdm-600", text='UHF-TE-Monitoringsystem PDM-600')
                        Sitelink(to="/de/products/uhfsensors/overview", text='UHF-TE-Sensoren')
                    
        div.margin-bottom
            p Impulsgenerator zur Erzeugung von breitbandigen Impulsen bis in den GHz-Bereich mit 600 V maximaler Impulsspannung. Dieser hochfrequente Impuls kann für den Performance Check an installierten UHF-Sensoren am Transformator verwendet werden.
            p Der Impuls kann per TTL Signal, durch eine Fotodiode, durch einen manuellen Triggerknopf und durch die Fernsteuerung per LWL getriggert werden. Außerdem kann er auf eine feste Wiederholrate per internem Takt eingestellt werden. Der Impulsgenerator wird per Lithium-Ionen-Akku betrieben und kann bei Bedarf komplett per LWL ferngesteuert werden.
            //- p Eine Version mit 50 V maximaler Spannung ist als HFIG-50 ebenfalls erhältlich.

        div.margin-bottom
            .column-container
                .column.align-top
                    span.bold Impuls im Zeitbereich
                    p 
                    picture.main-product-picture
                        source(type='image/avif', srcset='@/assets/photos/HFIG-600-timedomain.avif')
                        source(type='image/webp', srcset='@/assets/photos/HFIG-600-timedomain.webp')
                        img( src='@/assets/photos/HFIG-600-timedomain.png', width="80%", alt='HFIG-600 Impuls im Zeitbereich', title='HFIG-600 Impuls im Zeitbereich')
                    p Gemessen mit einem DSO mit:
                    ul
                        li 8&nbsp;GHz Analogbandbreite
                        li 25&nbsp;GS/s Sampling-Rate
                        li 12&nbsp;bit vertikale Auflösung
                .column.align-top
                    span.bold Impuls im Frequenzbereich
                    p 
                    picture.main-product-picture
                        source(type='image/avif', srcset='@/assets/photos/HFIG-600-frequencydomain.avif')
                        source(type='image/webp', srcset='@/assets/photos/HFIG-600-frequencydomain.webp')
                        img( src='@/assets/photos/HFIG-600-frequencydomain.png', width="80%", alt='HFIG-600 Impuls im Frequenzbereich', title='HFIG-600 Impuls im Frequenzbereich')
                    p Gemessen mit einem Spektrumanalysator mit:
                    ul
                        li 7&nbsp;GHz Analogbandbreite
                        li 3&nbsp;MHz Empfängerbandbreite (RBW)
                        li 10&nbsp;MHz Videobandbreite (VBW)
            p Die Plots zeigen die verwendete Standard Impulsform des HFIG-600. Auf Anfrage können auch Versionen des Impulsgenerators mit einer Kapazitäts-Entladung mit langem Rücken oder mit einem Rechteckimpuls erzeugt werden. Kontaktieren Sie uns bei Bedarf.
            //- p Hinweis: Da der Impulsgenerator HFIG-600 eine geringe Anstiegszeit unter 500 ps und eine Ausgangsspannung über 5 V aufweist, darf das Gerät nicht ohne Genehmigung aus der Europäischen Union exportiert werden (EU-Dual-Use-Verordnung).



    div.fullwidth(v-if="$route.params.lang == 'en'")

        div.title-container
            h1.product-title HFIG-600(-S)
            .subtitle Broadband VHF/UHF pulse generator with up to 600 V output voltage

        div.margin-bottom
            .column-container
                .column.center-content
                    picture.main-product-picture
                        source(type='image/avif', srcset='@/assets/photos/product_shots/HFIG-600.avif')
                        source(type='image/webp', srcset='@/assets/photos/product_shots/HFIG-600.webp')
                        img( src='@/assets/photos/product_shots/HFIG-600.png', width="50%", alt='VHF/UHF Pulse Generator HFIG-600', title='VHF/UHF Pulse Generator HFIG-600')
                    
                .column.factsandbluebox
                    .factbox
                        span.headline Key Features:
                        ul
                            li High Bandwidth 1&nbsp;GHz (-1&nbsp;dB) / 1.7&nbsp;GHz (-3&nbsp;dB)
                            li Short rise time 80&nbsp;ps
                            li Impulse width 200&nbsp;ps
                            li Output voltage up to 600&nbsp;V in 50&nbsp;Ω
                            li Battery powered
                            li FO controllable (S version)
                            li Various trigger options
                    .bluebox
                        //- Downloadlink(text='Datenblatt (pdf, deutsch)', link="/pdf/Datenblatt HFIG-600.pdf")
                        Downloadlink(text='Datasheet (pdf, english)', link="/pdf/Datasheet HFIG-600.pdf")
                        Maillink(to='support@bss-hs.de', sub='HFIG-600', text='Contact Us', size=30, strokeWidth=2)
                        Sitelink(to="/en/products/pdm-600", text='UHF PD Monitoring System PDM-600')
                        Sitelink(to="/en/products/uhfsensors/overview", text='UHF PD Sensors')
                    
        div.margin-bottom
            p Impulse generator for the generation of wideband pulses up to the GHz range with 600 V maximum impulse voltage. This pulse can be used for the performance check on UHF sensors installed at a transformer.
            p The pulse can be triggered by a TTL signal, by a photodiode, by a manual trigger button and by the remote control via fiber optic (FO) cable. In addition, it can be set to a fixed repetition rate per internal clock. The pulse generator is operated by lithium-ion battery and can be controlled remotely by FO if required.
            //- p A version with a lower maximum peak voltage of 50 V is available as HFIG-50.

        div.margin-bottom
            .column-container
                .column.align-top
                    span.bold Impulse in time domain
                    p 
                    picture.main-product-picture
                        source(type='image/avif', srcset='@/assets/photos/HFIG-600-timedomain.avif')
                        source(type='image/webp', srcset='@/assets/photos/HFIG-600-timedomain.webp')
                        img( src='@/assets/photos/HFIG-600-timedomain.png', width="80%", alt='HFIG-600 Impulse in Time-domain', title='HFIG-600 Impulse in Time-domain')
                    p measured using a DSO with
                    ul
                        li 8&nbsp;GHz analog bandwidth
                        li 25&nbsp;GS/s sampling rate
                        li 12&nbsp;bit vertical resolution
                .column.align-top
                    span.bold Impulse in frequency domain
                    p 
                    picture.main-product-picture
                        source(type='image/avif', srcset='@/assets/photos/HFIG-600-frequencydomain.avif')
                        source(type='image/webp', srcset='@/assets/photos/HFIG-600-frequencydomain.webp')
                        img( src='@/assets/photos/HFIG-600-frequencydomain.png', width="80%", alt='HFIG-600 Impulse in Frequency-domain', title='HFIG-600 Impulse in Frequency-domain')
                    p measured using a spectrum analyzer with
                    ul
                        li 7&nbsp;GHz analog bandwidth
                        li 3&nbsp;MHz reciever bandwidth (RBW)
                        li 10&nbsp;MHz video bandwidth (VBW)
                        
            p The plots show the standard impulse shape of the HFIG-600. On request, versions of the pulse generator with a capacity discharge with a RC fall time or with a rectangular pulse can be provided. Contact us for additional information.
            //- p Note: As the impulse generator HFIG-600 has a low rise time under 500 ps and a output voltage over 5 V, it is not allowed to export the device out of the European Union without permission (EU dual-use trade control).


</template>

<script>
export default {
    meta: {
        de: {
            title: "BSS | HFIG-600",
            description:
                "Breitbandiger VHF/UHF Impulsgenerator mit bis zu 600 V Ausgangsspannung",
        },
        en: {
            title: "BSS | HFIG-600",
            description:
                "Broadband VHF/UHF pulse generator with up to 600 V output voltage",
        },
    },
};
</script>

<style lang='sass' scoped>
</style>